import React, { useEffect, useState } from 'react';
import { listIAPs, createIAP, updateIAP, deleteIAP } from '../../services/api';

export default function MonetizationIAP({ appId }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ referenceName: '', productId: '', inAppPurchaseType: 'CONSUMABLE' });
  const [editName, setEditName] = useState('');
  const [editingId, setEditingId] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await listIAPs(appId);
      if (res.data?.success) setItems(res.data.items);
    } catch (e) {
      console.error('Failed to list IAPs', e);
    } finally { setLoading(false); }
  };

  useEffect(() => { if (appId) load(); }, [appId]);

  const create = async () => {
    if (!form.referenceName || !form.productId) { alert('Reference name and product id required'); return; }
    try {
      const res = await createIAP(appId, form);
      if (res.data?.success) {
        setForm({ referenceName: '', productId: '', inAppPurchaseType: form.inAppPurchaseType });
        await load();
      } else {
        const e = res.data?.error; alert(typeof e === 'string' ? e : (e?.message || JSON.stringify(e) || 'Failed to create IAP'));
      }
    } catch (e) {
      const err = e.response?.data?.error || e.message || e; alert(typeof err === 'string' ? err : JSON.stringify(err));
    }
  };

  const saveEdit = async () => {
    if (!editingId) return;
    try {
      const res = await updateIAP(editingId, { referenceName: editName });
      if (res.data?.success) { setEditingId(null); setEditName(''); await load(); }
      else {
        const e = res.data?.error; alert(typeof e === 'string' ? e : (e?.message || JSON.stringify(e) || 'Failed to update IAP'));
      }
    } catch (e) {
      const err = e.response?.data?.error || e.message || e; alert(typeof err === 'string' ? err : JSON.stringify(err));
    }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this IAP?')) return;
    try {
      const res = await deleteIAP(id);
      if (res.data?.success) await load();
      else { const e = res.data?.error; alert(typeof e === 'string' ? e : (e?.message || JSON.stringify(e) || 'Failed to delete IAP')); }
    } catch (e) {
      const err = e.response?.data?.error || e.message || e; alert(typeof err === 'string' ? err : JSON.stringify(err));
    }
  };

  return (
    <div>
      <h3 style={{ margin: '0 0 1.5rem 0' }}>In‑App Purchases</h3>
      <div className="form-group">
        <label className="form-label">Reference Name</label>
        <input className="form-input" value={form.referenceName} onChange={e => setForm({ ...form, referenceName: e.target.value })} />
      </div>
      <div className="form-group">
        <label className="form-label">Product ID</label>
        <input className="form-input" value={form.productId} onChange={e => setForm({ ...form, productId: e.target.value })} placeholder="com.your.app.iap1" />
      </div>
      <div className="form-group">
        <label className="form-label">Type</label>
        <select className="form-select" value={form.inAppPurchaseType} onChange={e => setForm({ ...form, inAppPurchaseType: e.target.value })}>
          <option value="CONSUMABLE">Consumable</option>
          <option value="NON_CONSUMABLE">Non‑Consumable</option>
          <option value="NON_RENEWING_SUBSCRIPTION">Non‑Renewing Subscription</option>
        </select>
      </div>
      <button className="btn btn-primary" onClick={create} disabled={loading}>
        Create
      </button>

      <div style={{ marginTop: '1rem' }}>
        {loading ? (<div className="loading-inline"><div className="spinner"/></div>) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>Product ID</th>
                <th>Reference</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {(items||[]).map(i => (
                <tr key={i.id}>
                  <td>{i.attributes?.productId}</td>
                  <td>
                    {editingId === i.id ? (
                      <div style={{ display:'flex', gap:'0.5rem' }}>
                        <input className="form-input" value={editName} onChange={e => setEditName(e.target.value)} />
                        <button className="btn btn-primary" onClick={saveEdit}>Save</button>
                        <button className="btn btn-secondary" onClick={() => { setEditingId(null); setEditName(''); }}>Cancel</button>
                      </div>
                    ) : (
                      i.attributes?.referenceName
                    )}
                  </td>
                  <td>{i.attributes?.inAppPurchaseType}</td>
                  <td>
                    {editingId !== i.id && (
                      <>
                        <button className="btn btn-secondary" onClick={() => { setEditingId(i.id); setEditName(i.attributes?.referenceName || ''); }}>Edit</button>
                        <button className="btn btn-secondary" style={{ marginLeft:'0.5rem' }} onClick={() => remove(i.id)}>Delete</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {(items||[]).length === 0 && (
                <tr>
                  <td colSpan={4} className="text-secondary" style={{ textAlign: 'center' }}>No in-app purchases yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
